import { render } from "./ShopDefaultHeroSection.vue?vue&type=template&id=1629c0c4&scoped=true"
import script from "./ShopDefaultHeroSection.vue?vue&type=script&lang=js"
export * from "./ShopDefaultHeroSection.vue?vue&type=script&lang=js"

import "./ShopDefaultHeroSection.vue?vue&type=style&index=0&id=1629c0c4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1629c0c4"]])

export default __exports__